import { router } from '@inertiajs/vue3'

router.on('navigate', (event) => {
    if (window.omnisend && typeof window.omnisend.push === 'function') {
        window.omnisend.push(['track', '$pageViewed']);
    }

    if (window.dataLayer) {
        window.dataLayer.push({
            event: 'page_view',
            url: event.detail.page.url,
        });
    }
});
